import React, { useState, useEffect } from 'react';
import circleImage from '../../assets/circle.png';
import rectangleImage from '../../assets/rectengle.png';
import logo from '../../assets/logo.png';
import { login } from '../../services/authService';

const LoginPage = ({ onLogin, onForgotPassword }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  useEffect(() => {
    const msg = localStorage.getItem('auth_error');
    if (msg) {
      setLoginError(msg);
      localStorage.removeItem('auth_error'); // show only once
    }
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset errors
    setEmailError('');
    setPasswordError('');
    setLoginError('');

    // Validate email
    if (!email.trim()) {
      setEmailError('Please Enter Email');
    }

    // Validate password
    if (!password.trim()) {
      setPasswordError('Please Enter Password');
    } else if (password.trim().length < 6) {
      setPasswordError('Password must be at least 6 characters');
    }

    // If there are errors, don't proceed
    if (!email.trim() || !password.trim() || password.trim().length < 6) {
      return;
    }

    setIsLoading(true);

    try {
      // Call login API
      const response = await login(email, password);

      // Store token from API response
      // authService returns response.data, so response is already the data object
      // Token might be in response.token, response.data.token, response.accessToken, etc.
      const token = response?.token || response?.data?.token || response?.accessToken || response?.data?.accessToken;

      if (token) {
        localStorage.setItem('token', token);

        // Call onLogin to show dashboard after successful login
        if (onLogin) {
          onLogin();
        }
      } else {
        setLoginError('Login successful but no token received. Please try again.');
      }
    } catch (error) {
      setLoginError(error.message || 'Login failed. Please check your credentials and try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    // Clear error when user starts typing
    if (emailError) {
      setEmailError('');
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    // Clear error when user starts typing or password becomes valid
    if (passwordError && newPassword.trim().length >= 8) {
      setPasswordError('');
    }
  };




  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#FDF6EF] relative overflow-hidden px-4 py-8"
    >

      <div className="absolute inset-0 blur-[80px]"></div>
      <img
        src={circleImage}
        alt="cicular decoration"
        className="absolute top-0 left-0 z-0 w-44 h-44 sm:w-72 sm:h-72 lg:w-80 lg:h-80 transform rotate-180"
      />
      <img
        src={circleImage}
        alt="circle decoration"
        className="absolute bottom-0 right-0 z-0 w-44 h-44 sm:w-72 sm:h-72 lg:w-80 lg:h-80 "
      />

      <div className="flex flex-col items-center relative z-10 w-full max-w-md">
        {/* Logo Section - Outside the sign-in box */}
        <div className="flex justify-center mb-3">
          <img
            src={logo}
            alt="Logo"
            className="h-14 sm:h-14 md:h-16 object-contain"
          />
        </div>

        <div
          className="w-full bg-white rounded-2xl border border-[#FDE8E0] shadow-[0_0_30px_rgba(0,0,0,0.15)] p-6 sm:p-8 md:p-8"
        >
          {/* Header Section */}
          <div className="text-center mb-6">
            <h1 className="text-2xl sm:text-4xl font-bold text-[#212121] mb-2">
              Sign In
            </h1>
            <p className="text-sm sm:text-[15px] font-regular text-gray-550 ">Enter your email and password to sign in!</p>

          </div>

          {/* Form Section */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email Field */}
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-bold text- mb-2"
              >
                Email*
              </label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={handleEmailChange}
                className="w-full px-3 py-2.5 border border-[#FDE8E0] rounded-[12px] outline-none text-sm text-gray-550 placeholder:text-gray-450 hover:border-[#FDE8E0] focus:border-[#FDE8E0] bg-white autofill:bg-white autofill:text-gray-550"
                placeholder="Enter your email"
                style={{
                  WebkitBoxShadow: '0 0 0 1000px white inset',
                  boxShadow: '0 0 0 1000px white inset',
                  WebkitTextFillColor: '#6B7280',
                }}
              />
              {emailError && (
                <p className="text-red-500 text-sm mt-1">{emailError}</p>
              )}
            </div>

            {/* Password Field */}
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-bold text-[#212121] mb-2"
              >
                Password*
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={handlePasswordChange}
                  className="w-full px-3 py-2.5 border border-[#FDE8E0] rounded-[12px] outline-none text-sm text-gray-550 placeholder:text-gray-450 hover:border-[#FDE8E0] focus:border-[#FDE8E0] bg-white autofill:bg-white autofill:text-gray-550 pr-10"
                  placeholder="Enter your password"
                  style={{
                    WebkitBoxShadow: '0 0 0 1000px white inset',
                    boxShadow: '0 0 0 1000px white inset',
                    WebkitTextFillColor: '#6B7280',
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 focus:outline-none"
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.82l2.92 2.92c1.51-1.26 2.7-2.89 3.44-4.74-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                    </svg>
                  )}
                </button>
              </div>
              {passwordError && (
                <p className="text-red-500 text-sm mt-1">{passwordError}</p>
              )}
            </div>


            {/* Forgot Password Link */}
            {/* <div className="text-right ">
          <div className="-mt-4">
            <button
              type="button"
              onClick={onForgotPassword}
              className="text-sm  text-[#58327E] hover:underline font-medium"
            >
              Forgot Password?
            </button>
            </div>
          </div> */}


            {/* Login Error Message */}
            {loginError && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {loginError}
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-[#58327E] border border-[#E4C5EF] text-white font-semibold py-3 px-4 rounded-full transition-all duration-200 shadow-md hover:shadow-lg text-sm sm:text-base uppercase relative overflow-hidden disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <div className="absolute left-0 top-0  h-full flex items-center -gap-2   pointer-events-none">
                <img
                  src={rectangleImage}
                  alt=""
                  className="h-full  object-cover opacity-100 brightness-0 invert"
                  style={{ width: '6%', height: '190%', marginLeft: '35px', rotate: '208deg' }}
                />
                <img
                  src={rectangleImage}
                  alt=""
                  className="h-full object-cover opacity-100 brightness-0 invert"
                  style={{ width: '30%' }}
                />
              </div>
              <span className="relative z-10">{isLoading ? 'Signing In...' : 'Sign In'}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

